export default {
  path: 'evaluations',
  name: 'subscription/evaluations',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-evaluations" */ './Evaluations')
}
